<template>
  <div class="upload_wrap">
    <div class="upload_content">
      <div class="upload_file" @click="uploadFiles">
        <div class="up_cons">
          <i class="el-icon-plus"></i>
          <span>{{ addText }}</span>
          <span>（{{ modelValue.length }}/{{ limit }}）</span>
        </div>
      </div>
      <input v-show="false" ref="fileIpt" type="file" @input="fileIptChange" :multiple="false" :accept="accept.join(',')">
      <div class="fileList_li" v-for="(item,index) in modelValue" :key="item">
        <img class="fileList_li_img" :src="item" alt="" />
        <div class="fileList_li_mask">
          <i class="el-icon-zoom-in icon" @click="handlePictureCardPreview(item)"></i>
          <i class="el-icon-delete icon" @click="handleRemove(index)"></i>
        </div>
      </div>
    </div>
    <el-dialog
      :visible.sync="dialogVisible"
      custom-class="preivew_img_dialog"
      :modal="false"
    >
      <img width="100%" :src="selImage" alt="" />
    </el-dialog>

    <el-dialog
			:modal-append-to-body="false"
			title="封面主图"
			:visible.sync="cutPicPop"
			width="600px"
			class="upload_cover"
			align="left"
			>
				<div class="upload_dialog_content" style="min-width:600px">
					<div class="upload_dialog_content_oper">
						<el-button  @click="openFile">
							<i class="iconfont">&#xe60f;</i>
							<span style="margin-left: 6px">选择本地图片</span>
						</el-button>
						<!-- <el-button @click="changeSuCai">
							<i class="iconfont">&#xe685;</i>
							<span style="margin-left: 6px">选择素材库图片</span>
						</el-button> -->
					</div>
					<div class="upload_cropper">
						<div class="upload_cropper_con" :style="{'width': cropperW + 'px', 'height': cropperH+ 'px'}">
							<cropper v-if="cropperFlag" :cropperUrl="cropperUrl" :ratio="ratio" :fileType="fileType" @coverFinsh="coverFinsh" :cropperW="cropperW" :cropperH="cropperH" @realTime="realTime" ref="cropper" ></cropper>
							<span v-else>选择一张本地图片编辑后上传封面</span>
						</div>
						<div class="cover_preview_con">
							<div class="cover_preview" :style="{'width': cropperW + 'px', 'height': cropperH+ 'px', 'zoom': 0.5}" >
								<img :src="previewObj.url" alt="" v-if="Object.values(previewObj).length" :style="previewObj.img"/>
							</div>
							<span>格式支持{{accept.join('、')}}</span>
						</div>
					</div>
				</div>
				<div slot="footer" class="dialog-footer">
					<el-button @click="cutPicPop = false">取 消</el-button>
					<el-button type="primary" @click="sure">确 定</el-button>
				</div>
		</el-dialog>
  </div>
</template>

<script>
import { cloneDeep } from "lodash-unified";
import { mapActions } from "vuex";
import { uploadQiNiuyun } from "@/components/upload/upload.js";
import cropper from '@/components/cropper/cropper.vue'
export default {
  components: {
    cropper
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    addText: {
      type: String,
      default: '添加图片'
    },
    accept: {
      type: Array,
      default: () => [".jpg", ".png", ".jpeg", ".tif", ".jfif"],
    },
    limit: {
      type: Number,
      default: 6,
    },
    maxSize: { // 图片最大体积,单位mb
      type: Number,
      default: 10
    },
    cropperW: {
      type: [Number, String],
      default: 220
    },
    cropperH: {
      type: [Number, String],
      default: 220
    },
    needCut: { // 需要剪切
      type: Boolean,
      default: false
    },
    ratio: {
      type: Array,
      default: () => [1, 1]
    },
  },
  mixins: [uploadQiNiuyun],
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      sizeFlag: true,
      isUpload: false,
      selImage:'',
      isUploading: false, // 上传中
      cutPicPop: false, // 剪切图片弹窗
      cropperFlag: false,
      cropperUrl: '',
      previewObj: {},
      fileType: ''
    };
  },
  computed: {
    modelValue: {
      get() {
        console.log(this.value, this.limit, "value----");
        return cloneDeep(this.value);
      },
      set(news) {
        this.$emit("input", news);
        return news;
      },
    },
  },
  methods: {
    ...mapActions("uploads", ["getUploaderToken"]),
    ...mapActions("xhsApis", ["uploadXhsPicAPI"]),
    realTime(obj) {
      this.previewObj = obj
    },
    // 点击 裁剪确定, 触发 -> coverFinsh
    sure() {
      this.$refs.cropper.uploadImg()
    },
    // 完成裁剪
    async coverFinsh(url) {
      // console.log('coverFinsh-url:',url)
      const files = new File(
        [url],
        this.fileObj.name, {
          type: url.type
        }
      )
      // console.log('coverFinsh-files:',files)
      this.picToNet(files)
      this.cutPicPop = false
    },
    openFile(){
      this.$refs.fileIpt.click()
    },
    // 选择图片文件
    async fileIptChange(e){
      // console.log("fileIptChange-e:",e.target.files[0])
      let file = e.target.files[0]
      let limitSize = this.maxSize // 最大限制
      if(file.size > limitSize*1024*1024){
        this.tipMessage(`文件大小不能超过${limitSize}MB`)
        return
      }
      if(this.needCut){ // 需要裁剪
        this.picToCropper(file)
      }else{
        this.picToNet(file)
      }
    },
    // 裁剪
    picToCropper(file){
      this.fileObj = file
      var reader = new FileReader()
      let that = this
      reader.onload = function(e) {
        var img = new Image()
        let url = ''
        if (typeof e.target.result === 'object') {
          url = window.URL.createObjectURL(new Blob([e.target.result]));
        } else {
          url = e.target.result;
        }
        img.src = url
        that.cropperUrl = url
        that.cropperFlag = true
      }
      if(!this.fileObj.url) {
        reader.readAsArrayBuffer(file)
      } else {
        that.cropperUrl = this.fileObj.url
        that.cropperFlag = true
      }
    },
    // 图片上传
    async picToNet(file){
      if(this.isUploading) {
        this.tipMessage('上传中,请稍候...')
        return
      }
      this.isUploading = true
      let formData = new FormData(); // 创建一个FormData对象
      formData.append('file', file);
      try {
        let res = await this.uploadXhsPicAPI(formData)
        this.isUploading = false
        this.modelValue.push(res.url)
        this.modelValue = [...this.modelValue]
      }catch(err){
        this.isUploading = false
        console.error('上传失败-err:', err)
      }
    },
    tipMessage(message, type="error", duration=3000) {
      this.$message({
        type,
        duration,
        message
      })
    },
    // 点击添加图片
    uploadFiles() {
      if(this.modelValue.length>=this.limit){
        return
      }
      if(this.needCut){ // 需要剪裁
        this.cutPicPop = true
      }else{
        this.$refs.fileIpt.click()
      }
    },
    handlePictureCardPreview(file) {
      this.selImage = file
      this.dialogVisible = true;
    },
    handleRemove(index) {
      console.log(index,'index-----')
      this.modelValue.splice(index,1)
      this.modelValue = [...this.modelValue]
    },
    handleChange(){}
  }
};
</script>

<style lang="less" scoped>
.preivew_img_dialog {
  margin-top: 24px !important;
  min-width: 50%;
  max-height: 90%;
  display: flex;
  flex-direction: column;
  .el-dialog__body {
    overflow-y: auto;
    flex: 1;
    height: 0;
  }
}
.upload_content {
  width:330px;
  display: flex;
  flex-wrap: wrap;
}
.upload_file {
  width: 100px;
  height: 100px;
  background-color: #fbfdff;
  border: 1px dashed #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 10px;
  cursor: pointer;
}
.up_cons {
  display: flex;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  color: #333;
  span{
   line-height: 20px;
  }
}
.fileList_li {
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #c0ccda;
  border-radius: 6px;
  box-sizing: border-box;
  width: 100px;
  height: 100px;
  margin: 0 8px 8px 0;
  display: inline-block;
  position: relative;
  .fileList_li_mask {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    transition: all 0.2s linear;
    transform: translateY(-100%);
    .icon {
      font-size: 16px;
      color: #fff;
      cursor: pointer;
      &:nth-child(2) {
        margin-left: 6px;
      }
    }
  }
  &:hover .fileList_li_mask {
    transform: translateY(0);
  }
  .fileList_li_img {
    width: 100%;
    object-fit: cover;
    height: 100%;
  }
}
.upload_cropper {
  margin-top: 32px;
  display: flex;
  .upload_cropper_con {
    background-color: #f3f4f9;
    border: 1px dashed #c7cada;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex-shrink: 0;
    >span {
      width: 132px;
      font-size: 12px;
      color: #999;
      line-height: 17px;
      text-align: center;

    }
  }
  .cover_preview_con {
    margin-left: 40px;
    flex-shrink: 0;
    >span {
      font-size: 12px;
      color: #888a95;
      line-height: 17px;
    }
    .cover_preview {
      background-color: #f3f4f9;
      border: 1px dashed #c7cada;
      overflow: hidden;
      transform-origin: 0 0;
      img {
        width: 100%;
        height: 100%;
      }
    }
  }
  
}
</style>